// components/SystemAnouncementsCard.jsx
import React, { useEffect, useState, useContext, useLayoutEffect } from "react";
import { AppContext } from "../util/AppContext";
import { getConfigValue } from "../util/getConfigValue";
import PropType from "prop-types";
import DOMPurify from "dompurify";
import { useErrorBoundary } from "react-error-boundary";
import { useLocation } from "react-router-dom";
import { createAnnoucementContext } from "../util/AnnoucementContext";

SystemAnouncementsCard.propTypes = { filters: PropType.object };

function SystemAnouncementsCard({ filters }) {
    const [appState] = useContext(AppContext);
    const cardEnabled =getConfigValue(appState?.config?.SystemAnnouncement?.Enabled, appState)?.Value === "true";
    const refetchAnnouncementInterval = getConfigValue(appState?.config?.SystemAnnouncement?.RefreshIntervalSeconds, appState)?.Value || 60;
    const announcmentPartition = "System";
    const { showBoundary } = useErrorBoundary();
    const location = useLocation();
    const [content, setContent] = useState("");
    const [dismissed, setDismissed] = useState(false);
    const [enabled, setEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [version, setVersion] = useState(0);

    const [announcementContext] = useState(() =>
        createAnnoucementContext(announcmentPartition, setVersion, {
            storageKey: "announcements",
            refetchAnnoucementInterval: refetchAnnouncementInterval,
            ttlMs: refetchAnnouncementInterval * 1000
        })
    );

    async function hydrate(fresh = false) {
        try {
            const data = await announcementContext.getAnnouncement(announcmentPartition, { fresh });

            if (!data?.id) {
                return;
            }

            const newHtml = DOMPurify.sanitize(data.content || "");

            setEnabled(Boolean(data.isActive));

            setContent(prev => {
                if (prev !== newHtml) {
                    setDismissed(false);
                    return newHtml;
                }

                return prev;
            });

        } catch (e) {
            showBoundary(e);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (!cardEnabled) {
            return;
        }

        hydrate(false);
    }, [cardEnabled]);

    useLayoutEffect(() => {
        if (!cardEnabled) {
            return;
        }

        hydrate(false);
    }, [location.pathname, cardEnabled]);

    useEffect(() => {
        if (!cardEnabled) {
            return;
        }

        hydrate(false);
    }, [version]);

    return (
        <>
            {cardEnabled && enabled && !dismissed && (
                <div className="system_announcement_container container-xl mt-4">
                    <div className="row justify-content-center">
                        {isLoading ? (
                            <div className="col-md-12 text-centered">
                                <p>{getConfigValue(appState.config.Common?.Loading, appState)?.Value}</p>
                            </div>
                        ) : (
                            <div className="col-md-12">
                                <div
                                    className="system_announcement alert-dismissible fade show d-flex align-items-center justify-content-between"
                                    role="alert">
                                    <div className="ql-editor mb-0" dangerouslySetInnerHTML={{ __html: content }} />
                                    <button
                                        type="button"
                                        className="system_announcement_close ms-3"
                                        aria-label="Close"
                                        onClick={() => setDismissed(true)}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default SystemAnouncementsCard;
